<template>
	<v-tooltip
		:text="`${showNova ? 'Nova' : user?.name} • ${new Date(message.timestamp).toLocaleTimeString()}`"
		location="top start"
	>
		<template v-slot:activator="{ props }">
			<span v-bind="props" style="height: 40px !important">
				<div
					v-if="message.isProcessing || playing"
					style="background: #4fc3f7; border-radius: 50%; height: 40px; width: 40px"
				>
					<NtaAudioIndicator
						color="#000000"
						width="30px"
						height="30px"
						style="margin-top: 4px; margin-left: 5px"
					/>
				</div>
				<Avatar
					v-else
					:image="showNova ? '/Nova-Small.png' : undefined"
					:icon="showBot ? 'mdi-robot' : undefined"
					:color="showNova ? '#4db6ac' : undefined"
					:text="
						showNova
							? undefined
							: showBot
							? undefined
							: `${user?.name?.split(' ')?.[0]?.[0] ?? ''}${user?.name?.split(' ')?.[1]?.[0] ?? ''}`
					"
					:nova-img="true"
				/>
			</span>
		</template>
	</v-tooltip>
</template>

<script setup lang="ts">
import type { Message, User } from "@lr-notitia/notitia-alternis/schemas";
import { NtaAudioIndicator } from "@lr-notitia/notitia-ui/components";
import { computed } from "vue";
import { useAudioPlayerStore } from "../../../../store/alternis/audioPlayer";
import Avatar from "./Avatar.vue";

const audioPlayerStore = useAudioPlayerStore();

const props = defineProps<{
	user: User | undefined;
	message: Message;
	showNova?: boolean;
	showBot?: boolean;
}>();
const playing = computed(() =>
	props.message.audioId ? audioPlayerStore.audioInstances.has(props.message.audioId) : false
);
</script>
